'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_1 = require('tslib');
var toast = require('./toast');

var instance = {
    create: function () {
        if (!instance.toast) {
            instance.toast = new toast.Toast({
                el: document.createElement('div'),
                propsData: {
                    onHide: instance.hide
                }
            });
            document.body.appendChild(instance.toast.$el);
        }
    },
    show: function (type, text, config) {
        if (type === void 0) { type = 'loading'; }
        instance.clear();
        instance.create();
        config = tslib_1.__assign({}, type === 'loading' ? { delay: 500 } : { delay: 0, duration: 3000 }, config);
        instance.shower = window.setTimeout(function () {
            if ('duration' in config) {
                instance.hider = window.setTimeout(instance.hide, config.duration);
            }
            instance.toast.show = true;
            instance.toast.text = text;
            instance.toast.type = type;
        }, config.delay);
    },
    hide: function () {
        instance.clear();
        instance.toast && (instance.toast.show = false);
    },
    clear: function () {
        instance.shower && clearTimeout(instance.shower);
        instance.hider && clearTimeout(instance.hider);
    }
};

exports.Toast = toast.Toast;
exports.default = instance;
